import React, { type JSX } from 'react';

import PasswordGate from '@/components/emotion-detector/PasswordGate';

import { useEmotionDetectorContext } from '../EmotionDetectorContextProvider';
import CameraScreen from '../screens/CameraScreen';
import HomeScreen from '../screens/HomeScreen';
import LogScreen from '../screens/LogScreen';
import SignupScreen from '../screens/SignupScreen';

const EmotionDetectorScreens = () => {
	const { activeComponentName } = useEmotionDetectorContext();

	const screenComponents: Record<string, JSX.Element> = {
		SignupScreen: <SignupScreen />,
		HomeScreen: <HomeScreen />,
		CameraScreen: <CameraScreen />,
		LogScreen: <LogScreen />,
	};

	return <PasswordGate>{screenComponents[activeComponentName]}</PasswordGate>;
};

export default EmotionDetectorScreens;
